import {changeEvent, dispatchCustomEvent} from "../../../../../../../webpack/modules/events";
import {isDesktop} from "../../../../../../../webpack/modules/devices";

changeEvent('#product-list-page .product-configuration-vinyl-rug-format[data-option-type="selectable"] input[name="vinyl-rug-format"]', true, function(element) {
    let mainContainer = isDesktop() ? element.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let container = element.closest('.product-configuration');
    let previewElement = mainContainer.querySelector('.open-configuration .preview-option-vinyl-rug-format');

    container.querySelectorAll('.pack.selected').forEach(option => option.classList.remove('selected'));
    element.nextElementSibling.classList.add('selected');
    mainContainer.querySelector('input[name="option-vinyl-rug-format"]').value = element.value;
    dispatchCustomEvent(
        'productVinylRugFormatChanged',
        {
            'option': container,
            'previewElement': previewElement
        }
    );
    container.dataset.completed = 'true';
    dispatchCustomEvent('productListProductConfigurationChanged');
});